module.exports = __webpack_public_path__ + "static/media/Configuración_ISR.04248558.svg";